import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H6 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo, ReactElement } from 'react';
import isEqual from 'react-fast-compare';

import { useIsMobileLayout } from '@/hooks';
import { SavedSearch } from '@/redux/api/saveSearch';

import { ManageSavedSearchCard, ManageSavedSearchCardProps } from './ManageSavedSearchCard';
import MobileSlideMenu from './MobileSlideMenu';

type Props = {
    className?: string;
    preparedSavedSearchFilter: ReactElement;
    searches?: SavedSearch[];
};

const ManageSavedSearchGridComponent = (props: Props) => {
    const { className, preparedSavedSearchFilter, searches } = props;
    const isMobile = useIsMobileLayout();

    const mapSavedSearchCards = (search: SavedSearch, index: number) => {
        const cardProps: ManageSavedSearchCardProps = {
            search,
        };

        return (
            <ManageSavedSearchCard
                key={index}
                {...cardProps}
            />
        );
    };

    return (
        <div className={cn('w-full p-0', className)}>
            {isMobile ? (
                <div className="flex flex-row items-center justify-between border-b border-border-secondary pb-md">
                    {searches.length === 1 ? (
                        <BodyPrimary color="secondary">
                            <FormattedMessage id="search_alerts.singleSearchTerm" />
                        </BodyPrimary>
                    ) : (
                        <BodyPrimary color="secondary">
                            <FormattedMessage
                                id="search_alerts.countSearchTerms"
                                values={{ count: searches.length }}
                            />
                        </BodyPrimary>
                    )}
                    <MobileSlideMenu preparedSavedSearchFilter={preparedSavedSearchFilter} />
                </div>
            ) : (
                <div className="grid grid-cols-[auto_150px_140px_115px] border-b border-border-secondary pb-[6px]">
                    <div className="col-start-1 col-end-2 flex flex-col items-start justify-center p-0">
                        <H6>
                            <FormattedMessage id="name" />
                        </H6>
                    </div>
                    <div className="col-start-2 col-end-3 flex items-center justify-end pl-sm text-right">
                        <H6>
                            <FormattedMessage id="search_alerts.newInPast24Hrs" />
                        </H6>
                    </div>
                    <div className="col-start-3 col-end-4 flex items-center justify-end pl-sm">
                        <H6>
                            <FormattedMessage id="search_alerts.dateAdded" />
                        </H6>
                    </div>
                </div>
            )}
            {searches.map(mapSavedSearchCards)}
        </div>
    );
};

export const ManageSavedSearchGrid = memo<Props>(ManageSavedSearchGridComponent, isEqual);
